import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { chercherNouvelleVersion } from '../lib/majApplication'
import { layout } from '../design/tokens'

/**
 * Force le rechargement des données de l'écran.
 *
 * Ajouté à la demande : c'est la sortie de secours quand une liste affiche un état périmé.
 * Il vide tout le cache de requêtes plutôt que la seule clé de l'écran courant — un bouton
 * d'actualisation qui laisserait une vue voisine fausse ne remplirait pas son office.
 *
 * Il demande aussi au navigateur s'il existe une version plus récente de l'application. Sans
 * cela, le bouton ne rafraîchissait que les données : sur un téléphone où l'application reste
 * ouverte, on appuyait dessus sans jamais voir les nouvelles fonctions. Si une version neuve
 * existe, la page se recharge d'elle-même ; sinon rien ne bouge visiblement.
 */
export function BoutonActualiser() {
  const queryClient = useQueryClient()
  const [encours, setEncours] = useState(false)

  return (
    <button
      type="button"
      aria-label="Actualiser"
      title="Actualiser"
      disabled={encours}
      onClick={async () => {
        setEncours(true)
        try {
          await Promise.all([
            queryClient.invalidateQueries(),
            // Lancée en parallèle : elle n'a pas de résultat à attendre, et un serveur lent ne
            // doit pas retarder le rafraîchissement des données.
            chercherNouvelleVersion(),
          ])
        } finally {
          setEncours(false)
        }
      }}
      className="flex shrink-0 items-center justify-center rounded-full border border-border bg-card text-accent disabled:opacity-60"
      style={{ width: layout.minimumTouchTarget, height: layout.minimumTouchTarget }}
    >
      {/* Flèche circulaire dessinée en SVG : aucune fonte d'icônes à charger, et le trait suit
          la couleur du texte. La rotation ne tourne que pendant l'appel, et la préférence
          « mouvement réduit » l'annule comme toute autre animation (theme.css). */}
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        style={encours ? { animation: 'tourner 900ms linear infinite' } : undefined}
      >
        <path d="M21 12a9 9 0 1 1-3.2-6.9" />
        <polyline points="21 3 21 9 15 9" />
      </svg>
    </button>
  )
}
